export const sortMenu = menu => {
  menu.sort((x, y) => {
    if (x.order < y.order) {
      return -1;
    }
    if (x.order > y.order) {
      return 1;
    }
    return 0;
  });
  return menu;
};
const Menu = [
  { header: 'Module', order: 1 },
  {
    title: 'Accueil',
    group: 'apps',
    icon: '$iconHome',
    href: '/',
  },
  {
    title: 'Soumissions',
    group: 'apps',
    icon: '$iconSubmission',
    name: 'Jobs',
    order: 3,
  },
  {
    title: 'Matériaux',
    group: 'apps',
    icon: '$iconMaterial',
    name: 'Materials',
    order: 4,
  },
  {
    title: 'Corps de métier',
    group: 'apps',
    icon: '$iconTrade',
    name: 'Labors',
    order: 5,
  },
];

export default sortMenu(Menu);
